import React, { useState } from 'react';

import { Box, Grid, Type, Btn, FieldRadio } from '@saladbob/sassafras'

import { Team } from '../../types';

type Props = {
    team1: Team,
    team2: Team,
    game: any,
    onForfeit?: (id: string) => void,
};

const ForfeitTeam: React.FC<Props> = ({ team1, team2, game, onForfeit }) => {
    const teams = [{
        value: team1.id,
        label: team1.name,
    }, {
        value: team2.id,
        label: team2.name,
    }];

    const [teamId, setTeamId] = useState();

    return (
        <Box>
            <Grid columns="1fr min-content" columnGap="md">
                <FieldRadio
                    columns="1fr 1fr"
                    margin={0}
                    name="team"
                    options={teams}
                    value={teamId}
                    onChange={changeTeam}
                    checkedColor="secondary"
                    uncheckedOutline
                    controlled
                />
                <Btn onClick={forfeitTeam}>
                    <Type nowrap>Forfeit Team</Type>
                </Btn>
            </Grid>
        </Box>
    );

    function changeTeam (e) {
        setTeamId(e.target.value);
    }

    async function forfeitTeam () {
        const data = {
            forfeit: teamId,
        };

        if (typeof onForfeit === 'function') {
            onForfeit(teamId);
        }

        const team = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/game/${game.id}`, {
            method: 'PATCH',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
        });
    }
}

export default ForfeitTeam;